"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pendingKnockRequestSelector = void 0;
var _reselect = require("reselect");
var _constants = require("@studio/constants");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function selectKnocks(state) {
  return state.knocks;
}
function sortByRecent(a, b) {
  return a.createdOn - b.createdOn;
}
function filterPendingStatus(req) {
  return req.status === _constants.PENDING;
}
function selectDirectorRequests(state) {
  return state.directorRequests || [];
}
var pendingKnockRequestSelector = exports.pendingKnockRequestSelector = (0, _reselect.createSelector)(selectKnocks, selectDirectorRequests, function (knocks, directorRequests) {
  return [].concat(_toConsumableArray(knocks), _toConsumableArray(directorRequests)).filter(filterPendingStatus).sort(sortByRecent);
});